import { create } from 'zustand';
import { ShipmentDto } from './shipment';
import { BagDto } from '@features/ManualSorting/model/manualSorting';

type State = {
  currentShipment: ShipmentDto | null;
  handleChangeCurrentShipment: (shipment: ShipmentDto | null) => void;
  isLoadingDataForScanning: boolean;

  bagsData: BagDto[];
  handleChangeBagData: (bagsData: BagDto[]) => void;

  // Был ли за текущую сессию сканирования хотя бы один успешный пик (добавление/удаление мешка).
  // По нему решаем, нужно ли рефрешить таблицу отгрузок при закрытии страницы пика.
  hasSuccessfulPick: boolean;
  setHasSuccessfulPick: (value: boolean) => void;
};

const init = {
  currentShipment: null,
  isLoadingDataForScanning: false,
  bagsData: [],
  hasSuccessfulPick: false,
};

export const useShipmentStore = create<State>((set) => ({
  ...init,
  handleChangeCurrentShipment: (currentShipment) => set({ currentShipment }),
  handleChangeBagData: (bagsData) => set({ bagsData }),
  setHasSuccessfulPick: (hasSuccessfulPick) => set({ hasSuccessfulPick }),
}));
